import Cookies from 'js-cookie'

let store = {}
const webStorage = {
  getItem (key) {
    try {
      return localStorage.getItem(key) || store[key] || null
    } catch (e) {
      console.log(e)
    }
  },
  setItem (key, value) {
    if (Cookies.get('istaging_cookie')) {
      try {
        localStorage.setItem(key, value)
      } catch (e) {
        console.log(e)
      }
    } else {
      store[key] = value
    }
  },
  removeItem (key) {
    try {
      localStorage.removeItem(key)
      delete store[key]
    } catch (e) {
      console.log(e)
    }
  },
  clear (storage) {
    try {
      localStorage.clear()
      store = {}
    } catch (e) {
      console.log(e)
    }
  }
}
export default webStorage
